import type { CSSProperties } from 'react';
import { LettersBanner } from '@/components/round/LettersBanner';
import styles from './SceneContent.module.css';

const TG_LINK = 'https://t.me/skvoz_bot';
const TG_HANDLE = '@skvoz_bot';

const HOW_STEPS = [
  { letter: 'К', color: 'var(--color-l1)', title: 'Буквы по порядку', desc: 'К → О → Т должны идти в слове по очереди' },
  { letter: 'О', color: 'var(--color-l2)', title: 'Дальше — дороже', desc: 'Шире расстояние и длиннее слово — больше очков' },
  { letter: 'Т', color: 'var(--color-l3)', title: '90 секунд на раунд', desc: 'Успей найти больше слов, чем соперники' },
];

function SceneWordmark() {
  return (
    <div className={styles.wordmark} aria-label="Сквозь">
      {'Сквозь'.split('').map((ch, i) => (
        <span key={i} className={styles.wordmarkChar}>{ch}</span>
      ))}
    </div>
  );
}

function SceneMotif() {
  return (
    <div className={styles.motif}>
      <div className={styles.motifHalo} aria-hidden="true" />
      <div className={styles.motifBanner}>
        <LettersBanner letters={['к', 'о', 'т'] as const} size="lg" />
      </div>
    </div>
  );
}

function SceneHowto() {
  return (
    <div className={styles.howto}>
      {HOW_STEPS.map((s, i) => (
        <div key={i} className={styles.howtoStep}>
          <span
            className={styles.howtoBadge}
            style={{ color: s.color, borderColor: s.color, boxShadow: `0 0 16px -8px ${s.color}` } as CSSProperties}
          >
            {s.letter}
          </span>
          <div className={styles.howtoText}>
            <span className={styles.howtoTitle}>{s.title}</span>
            <span className={styles.howtoDesc}>{s.desc}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

function SceneCta() {
  return (
    <div className={styles.cta}>
      <a
        href={TG_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.ctaButton}
      >
        <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M21.9 4.3 18.6 19.6c-.25 1.1-.9 1.37-1.83.85l-5.06-3.73-2.44 2.35c-.27.27-.5.5-1.02.5l.36-5.16L17 5.6c.4-.36-.09-.56-.62-.2L6.1 12.07 1.7 10.7c-.96-.3-.98-.96.2-1.42l19.3-7.44c.8-.3 1.5.18 1.24 1.46Z" />
        </svg>
        Открыть в Telegram
      </a>
      <span className={styles.ctaChip}>
        <span className={styles.ctaOnline} />
        <span className={styles.ctaHandle}>{TG_HANDLE}</span>
        <span>· играй с друзьями</span>
      </span>
    </div>
  );
}

export function SceneContent() {
  return (
    <>
      <SceneWordmark />
      <p className={styles.tag}>
        Словесная мультиплеер-игра. Придумывай слова, где буквы идут по маршруту.
      </p>
      <SceneMotif />
      <SceneHowto />
      <SceneCta />
    </>
  );
}
